import { useMemo } from 'react'
import { age } from 'Data/format.js'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return

    let result = []
    // extra safety check since it returns both the old and new fields
    // will be removed once the new search is used by all clinics
    if (Array.isArray(data)) {
      result = data
    } else if (Array.isArray(data.search_search)) {
      result = data.search_search
    } else {
      result = data.vaxiom_persons_search
    }

    let persons = result
      .filter(item => !!item.person)
      .map(item => {
        let phones = item.person.phones
          .map(item => {
            let number = item.contact_method.phone?.number

            if (!number) return false

            return {
              id: item.id,
              number,
              description: item.description,
            }
          })
          .filter(Boolean)

        let is_patient = !!item.person.patient
        let is_payer =
          age(item.person.birth_date) > 18 &&
          item.person.person_payment_account !== null
        let is_employee = item.person.employment_contracts?.length > 0

        let external_professional =
          item.person.other_professional_relationships?.[0]
        let is_external_professional = Boolean(external_professional)
        let external_professional_id = external_professional?.id
        let external_professional_info = [
          external_professional?.employee_type?.name,
          external_professional?.external_office?.name,
          external_professional?.external_office?.postal_address?.state,
        ]
          .filter(Boolean)
          .join(', ')

        return {
          ...item.person,
          is_patient,
          is_payer,
          is_employee,
          is_external_professional,
          is_lead: false,
          phones,
          external_professional_id,
          external_professional_info: external_professional_info || null,
        }
      })
      .filter(Boolean)

    let leads = result
      .filter(item => !!item.lead)
      .map(item => {
        let phones = []
        if (item.lead.phone_number) {
          phones.push({
            number: item.lead.phone_number,
          })
        }
        return {
          ...item.lead,
          leadId: item.lead.id,
          phones,
          is_external_professional: false,
          is_patient: false,
          is_payor: false,
          is_employee: false,
          is_lead: true,
        }
      })

    return [...persons, ...leads]
  }, [data]) // eslint-disable-line
  // ignore transform
}
